/**
 * Mirror of the RFC 7807 Problem Details contract emitted by the API server
 * (see Phase 2 §7.2 and the IT-API-Claude Invetrak.Api.ErrorHandling code).
 * The `errorCode` and `correlationId` extensions are present on every
 * server-emitted error.
 */
export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  errorCode?: string;
  correlationId?: string;
  /** Domain-specific machine-readable context (item SKU, location, etc.). */
  extensions?: Record<string, unknown>;
}

/**
 * Thrown by the fetch wrapper when the server returns an error. Carries the
 * Problem Details payload so the UI can branch on `errorCode` and surface
 * the `correlationId` to the user.
 */
export class ApiError extends Error {
  public readonly status: number;
  public readonly problem: ProblemDetails;

  public constructor(status: number, problem: ProblemDetails) {
    super(problem.detail ?? problem.title ?? `HTTP ${status}`);
    this.name = 'ApiError';
    this.status = status;
    this.problem = problem;
  }
}
